import { motion } from 'framer-motion';

export default function SafetyAssurance() {
  const items = [
    {
      title: 'Responsible, Ethical Breeder',
      desc: 'We adhere to strict, humane breeding standards with full transparency and care.'
    },
    {
      title: 'Health Guarantee',
      desc: 'Kittens receive comprehensive veterinary checks, vaccinations, and a written health guarantee.'
    },
    {
      title: 'Secure, Verified Payments',
      desc: 'Protected payment options with clear, traceable invoices. No requests for unverified transfers.'
    },
    {
      title: 'Privacy & Data Protection',
      desc: 'We respect your privacy. Any shared information is kept confidential and used only to serve you.'
    },
    {
      title: 'Lifetime Support',
      desc: 'We’re here for you even after adoption for advice and guidance.'
    },
    {
      title: 'Transparent Policies',
      desc: 'Clear adoption process, fees, and expectations with no hidden terms.'
    }
  ];

  return (
    <section className="py-20 bg-slate-50 dark:bg-slate-900">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <motion.h2
            className="text-3xl md:text-4xl font-display font-bold text-slate-900 dark:text-white"
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
          >
            Safety, Trust, and Care First
          </motion.h2>
          <motion.p
            className="mt-4 text-slate-600 dark:text-slate-300"
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.1 }}
          >
            We understand adopting a new family member is a big decision. Our promise is a safe, transparent, and caring experience from the first message to life-long support.
          </motion.p>
        </div>

        <div className="bg-soft-gold/10 p-8 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold text-warm-brown mb-4">Safety Assurance</h2>
          <motion.ul
            className="space-y-4"
            initial="hidden"
            animate="visible"
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: {
                opacity: 1,
                y: 0,
                transition: { staggerChildren: 0.2, duration: 0.8 },
              },
            }}
          >
            {items.map((item, index) => (
              <motion.li
                key={index}
                className="flex items-center space-x-4"
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 },
                }}
              >
                <div className="mt-1 w-6 h-6 rounded-full bg-green-100 dark:bg-green-900/40 flex items-center justify-center">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-green-600 dark:text-green-400"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg>
                </div>
                <span className="text-sm text-warm-brown/70">{item.title}</span>
              </motion.li>
            ))}
          </motion.ul>
        </div>

        <div className="max-w-4xl mx-auto mt-12 rounded-2xl p-6 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800">
          <p className="text-slate-800 dark:text-blue-100 text-sm md:text-base">
            We never rush decisions or pressure families. We welcome verified references and visits by appointment when appropriate. Please contact us with any questions—our goal is to help you feel informed, safe, and excited about welcoming a new companion.
          </p>
        </div>
      </div>
    </section>
  );
}
